
import React from "react";
import AppBar from "../../Components/header/index";
import AppProvider from "./../../Components/bootstrap"
import Mentor from "../../Screens/MentorProfile/Components/similarMentor"
import MentorProfile1 from "../../Screens/MentorProfile/Components/mentorProfile"
import MentorProfile from "../../Screens/MentorProfile/Components/content"
import { useAuthenticated } from 'react-admin'
const MentorProfilePage = props => {
  useAuthenticated();
  return (
    <div style={{ zoom: "88%", }}>
      <AppProvider>
          <AppBar />
          <MentorProfile1 showButton={true}   typography="Home/ Mentor Profile" />
          <div >
            <MentorProfile />
            {/* <Form
              initialValues={{
                // isMentor
              }}
              onSubmit={async response => {
              }}
              keepDirtyOnReinitialize
              render={MentorProfile}
            /> */}
                {
                    <Mentor/>
                }
          </div>
      </AppProvider>
    </div>
  );
};
export default MentorProfilePage;
